/**
 * LC-669: value for Encompass field 315 (URLA "Loan Originator Organization Name").
 *
 * Field 315 must carry the TPO's legal company name (the value written to TPO.X17),
 * never the internal TPO organization name (TPO.X14), which includes Logan channel
 * suffixes such as "(WHS)".
 *
 * Order of preference:
 *   1. loanData.tpo.companyLegalName: the exact value sent to Encompass as TPO.X17
 *   2. organization.company_legal_name: the selected TPO organization's legal name
 *   3. organization.name: only when no legal name is on file, so field 315 is
 *      never blanked out. It logs a warning so the missing legal name can be fixed.
 *
 * DBA (TPO.X24) handling is out of scope and will come with LC-481.
 */
const clean = (value) => (typeof value === "string" ? value.trim() : "");

export const getOriginatorCompanyName = (loanData, organization) => {
	const legalName =
		clean(loanData?.tpo?.companyLegalName) ||
		clean(organization?.company_legal_name);

	if (legalName) {
		return legalName;
	}

	const fallbackName = clean(organization?.name);
	if (fallbackName) {
		console.warn(
			"LC-669: no TPO legal company name available; falling back to organization name for field 315",
			fallbackName
		);
	}
	return fallbackName;
};
